import { JobApplicantSubBaseViewController } from '@/views/portal/hr/my_profile/JobApplicantSubBaseViewController';

export class JobApplicantSkillSubViewController extends JobApplicantSubBaseViewController {
	constructor( options = {} ) {
		_.defaults( options, {} );

		super( options );
	}

	init( options ) {
		this.qualification_type_id = 10;
	}

	initOptions() {
		var $this = this;
		this.api.getJobApplicantSkillOptions( 'proficiency', {
			onResult: function( result ) {
				$this.setSourceData( 'proficiency_id', result.getResult(), true );
			}
		} );
		var args = {};
		var filter_data = {};
		filter_data.type_id = [this.qualification_type_id];
		args.filter_data = filter_data;
		args.filter_columns = {
			'id': true,
			'name': true
		};
		this.qualification_api.getQualification( args, true, {
			onResult: function( result ) {
				var res = result.getResult();
				var options = {};
				for ( var i in res ) {
					if ( !res.hasOwnProperty( i ) ) {
						continue;
					}
					var row = res[i];
					options[row.id] = $.i18n._( row.name );
				}
				$this.setSourceData( 'qualification_id', options, true );
			}
		} );
	}

	getJobApplicantSkill( callback ) {
		var $this = this;
		var filter = {};
		filter.filter_data = {};
		filter.filter_data.id = this.model.id;
		this.api['getJobApplicantSkill']( filter, {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					var result_data = result.getResult();
					if ( !result_data ) {
						result_data = [];
					}
					result_data = result_data[0];
					$this.model.set( result_data );
					if ( callback ) {
						callback();
					}
				} else {
					$this.showErrorAlert( result );
					ProgressBar.closeOverlay();
				}
			}
		} );
	}

	setCurrentEditRecordData() {
		super.setCurrentEditRecordData();
		var field_selector;
		var field_control;
		//Set current edit record data to all widgets
		if ( !Global.isSet( this.model.get( 'enable_calc_experience' ) ) ) {
			this.model.set( 'enable_calc_experience', false );
		}
		for ( var key in this.model.attributes ) {
			if ( !this.model.has( key ) ) {
				continue;
			}
			// if ( this.current_edit_record[key] === false ) {
			// 	this.current_edit_record[key] = '';
			// }
			switch ( key ) {
				// case 'country':
				// 	// if ( this.current_edit_record[key] === false ) {
				// 	// 	this.current_edit_record[key] = '';
				// 	// }
				// 	field_selector = 'select[name="' + key + '"]';
				// 	this.$(field_selector ).val( this.model.get(key) );
				// 	if ( key === 'country' ) {
				// 		this.eSetProvince( this.model.get(key) );
				// 	}
				// 	break
				case 'enable_calc_experience':
					field_selector = 'input[name="' + key + '"]';
					if ( this.model.get( key ) === true ) {
						this.$( field_selector ).prop( 'checked', 'checked' );
					} else if ( this.model.get( key ) === false ) {
						this.$( field_selector ).removeAttr( 'checked' );
					}
					break;
				default:
					if ( this.model.get( key ) === false ) {
						this.model.set( key, '' );
						if ( key === 'qualification_id' && this.enable_add_qualification ) {
							this.showAddQualificationContainer();
						}
					}
					field_selector = '.form-control[name="' + key + '"]';
					field_control = this.$( field_selector );
					if ( field_control && field_control[0] ) {
						this.$( field_selector ).val( this.model.get( key ) );
					}
					break;

			}
		}
		// this.collectUIDataToCurrentEditRecord();
		this.setEditViewDataDone();
	}

	setEditViewDataDone() {
		if ( this.model.get( 'enable_calc_experience' ) === true ) {
			this.$( 'input[name="experience"]' ).attr( 'readonly', 'true' );
		} else {
			this.$( 'input[name="experience"]' ).removeAttr( 'readonly' );
		}
		$( '.edit-view-tab-bar' ).css( 'opacity', 1 );
	}

	onFormItemChange( e, doNotValidate ) {
		var key = e.currentTarget.name;
		this.model.set( key, $( e.currentTarget ).val() );
		if ( this.model.get( 'first_used_date' ) ) {
			this.model.set( 'enable_calc_experience', true );
			this.$( 'input[name="enable_calc_experience"]' ).prop( 'checked', 'checked' );
			this.$( 'input[name="enable_calc_experience"]' )[0].checked = true;
			this.$( 'input[name="enable_calc_experience"]' ).attr( 'disabled', 'disabled' );
		} else {
			this.model.set( 'enable_calc_experience', false );
			if ( this.$( 'input[name="enable_calc_experience"]' ) && this.$( 'input[name="enable_calc_experience"]' )[0] ) {
				this.$( 'input[name="enable_calc_experience"]' ).removeAttr( 'checked' );
				this.$( 'input[name="enable_calc_experience"]' )[0].checked = false;
				this.$( 'input[name="enable_calc_experience"]' ).removeAttr( 'disabled' );
			}
		}
		switch ( key ) {
			// case 'country':
			// case 'identification_country':
			// 	var widget = this.$('select[name="' + key + '"]');
			// 	widget.val( null );
			// 	break;
			case 'qualification_id':
				if ( this.model.get( key ) === '' && this.enable_add_qualification ) {
					this.showAddQualificationContainer();
					doNotValidate = true;
				} else {
					this.hideAddQualificationContainer();
				}
				break;
			case 'enable_calc_experience':
				if ( $( e.currentTarget ).is( ':checked' ) ) {
					this.model.set( key, true );
					this.calcExperience();
				} else {
					this.model.set( key, false );
					this.$( 'input[name="experience"]' ).removeAttr( 'readonly' );
				}
				break;
			case 'last_used_date':
			case 'first_used_date':
				// if ( this.model.get('enable_calc_experience') === true ) {
				// 	this.calcExperience();
				// }
				this.calcExperience();
				break;
		}
		// if ( key == 'country' ) {
		// 	this.eSetProvince( this.$('select[name="country"]').val(), true );
		// 	// this.clearErrorTips();
		// 	// return;
		// }
		if ( !doNotValidate ) {
			this.validate();
		}
	}

	calcExperience() {
		if ( this.model.get( 'enable_calc_experience' ) === true ) {
			this.$( 'input[name="experience"]' ).attr( 'readonly', 'true' );
		} else {
			this.$( 'input[name="experience"]' ).removeAttr( 'readonly' );
		}
		var first_used_date = this.$( 'input[name="first_used_date"]' ).val();
		var last_used_date = this.$( 'input[name="last_used_date"]' ).val();
		last_used_date = last_used_date ? last_used_date : new Date().format( 'DD-MMM-YY' );
		var experience = 0;
		if ( first_used_date !== '' && last_used_date !== '' ) {
			experience = this.api.calcExperience( first_used_date, last_used_date, { async: false } ).getResult();
			this.$( 'input[name="experience"]' ).val( experience );
		} else {
			this.$( 'input[name="experience"]' ).val( experience );
		}
		this.model.set( 'experience', experience );
	}

	// eSetProvince: function( val, refresh ) {
	// 	var $this = this;
	// 	if ( !val || val === '-1' || val === '0' ) {
	// 		$this.e_province_array = [];
	// 		$this.setSourceData( 'province', [] );
	// 	} else {
	// 		this.company_api.getOptions( 'province', val, {
	// 			onResult: function( res ) {
	// 				res = res.getResult();
	// 				if ( !res ) {
	// 					res = [];
	// 				}
	// 				$this.e_province_array = Global.buildRecordArray( res );
	// 				if ( refresh && $this.e_province_array.length > 0 ) {
	// 					$this.model.set( 'province', $this.e_province_array[0].value )
	// 					$this.$('select[name="province"]').val( $this.model.get( 'province') );
	// 				}
	// 				$this.setSourceData( 'province', res );
	// 			}
	// 		} );
	// 	}
	// },
}
